<template>
    <div class="holdRuleGroups">
        <page-title title="Hold rule groups" icon="pe-7s-flag">
        </page-title>

        <div class="card mb-4">
            <div class="card-body">
                <div class="row">
                    <div class="col-12" v-if="groupsDataLoading">
                        <h5 class="card-title">
                            Hold Groups Ophalen...
                            <font-awesome-icon icon="spinner" spin/>
                        </h5>
                    </div>

                    <div class="col-12" v-else>
                        <h5 class="card-title">
                            Hold Groups
                        </h5>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <b-table
                    v-if="!groupsDataLoading"
                    :items="this.groupsData"
                    :fields="this.fields"
                    responsive
                >

                    <template v-slot:cell(actions)="data">
                        <div class="d-flex flex-row">
                            <b-button v-if="hasPermission('holdrules.view')"
                                      :to="{ name: 'holdRuleGroupView', params: { groupIdentifier: data.item.identifier } }"
                                      class="btn btn-sm text-body"
                                      variant="link"
                            >
                                <font-awesome-icon icon="eye"/>
                            </b-button>
                            <b-button v-if="hasPermission('holdrules.edit')"
                                :to="{ name: 'holdRuleGroupEdit', params: { groupIdentifier: data.item.identifier } }"
                                class="btn btn-sm text-primary"
                                variant="link"
                            >
                                <i  class="far fa-pencil-alt"/>
                            </b-button>
                            <b-button v-if="hasPermission('holdrules.edit')"
                                      @click="deleteButtonHandler(data.item)"
                                      class="btn btn-sm text-danger"
                                      variant="link"
                            >
                                <font-awesome-icon icon="trash"/>
                            </b-button>
                        </div>
                    </template>

                </b-table>
            </div>

        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';

export default {
    name: "HoldRuleGroups",

    components: {
        PageTitle
    },

    data() {
        return {
            groupsDataLoading: true,
            groupsData: [],
            fields: [
                /**
                 * The columns for the table, in the form of
                 * [{ key: 'display_name', label: 'Weergavenaam', formatter: () ... }, ...]
                 * @see https://bootstrap-vue.org/docs/components/table#fields-as-an-array-of-objects
                 */
                {key: 'display_name', label: 'Naam'},
                {key: 'is_active', label: 'Actief', formatter: (value) => value ? 'Ja' : 'Nee'},
                {key: 'is_status_hold_final', label: 'Is definitief', formatter: (value) => value ? 'Ja' : 'Nee'},
                {key: 'is_approvable', label: 'Orderdata wijziging benodigd', formatter: (value) => !value ? 'Ja' : 'Nee'},
                {key: 'actions', label: 'Acties'},
            ]
        }
    },

    methods: {
        fetchGroupsData() {
            const apiPath = `/api/rest/hold-rule-groups`;

            this.$http.get(apiPath)
                .then(response => {
                    this.groupsData = response.data;
                })
                .catch(e => {
                    this.$alert('Er is iets misgegaan bij het opvragen van de Hold Rule Groups', 'danger', true);
                    console.error(e);
                })
                .then(() => {
                    this.groupsDataLoading = false;
                });
        },

        deleteButtonHandler(item) {
            this.$router.push({name: 'holdRuleGroupDelete', params: {groupIdentifier: item.identifier}});
        },
    },

    mounted() {
        this.fetchGroupsData();
    }
}
</script>
